import Swal from 'sweetalert2'
import { $axios } from '@/modules/http/axios'
import emitter from '@/modules/events/emitter'
import notificationStatus from '@/modules/sms/notificationStatus'

const notificationsModule = {
  namespaced: true,
  actions: {
    async sendAllNotifications ({ commit, dispatch }) {
      const dialogResult = await Swal.fire({
        title: 'Czy na pewno wysłać wszystkie przygotowane wiadomości SMS?',
        icon: 'question',
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: 'Nie',
        confirmButtonText: 'Tak'
      })

      if (dialogResult.isConfirmed) {
        await this.tasks.forEach(task => {
          if (task.notification && !task.notification.draft && task.notification.contentEditedAfterSend) {
            dispatch('sendNotification', task)
          }
        })
        await Swal.fire('Wysłano przygotowane powiadomienia SMS', '', 'success')
      }
    },

    async sendNotification ({ commit }, task, showAlert = true) {
      const postData = [task.notification.id]
      const dynamicAlertParams = {
        confirmButtonText: task.notification?.status === notificationStatus.PENDING ? 'Wyślij SMS' : 'Wyślij ponownie SMS'
      }

      try {
        const input = await Swal.fire({
          title: 'Ustal treść wiadomości SMS',
          input: 'textarea',
          inputAttributes: {
            rows: 12
          },
          icon: 'info',
          customClass: 'swal-wide-container',
          showCancelButton: true,
          cancelButtonText: 'OK',
          confirmButtonText: dynamicAlertParams.confirmButtonText,
          inputValue: task.notification.content.replace(/\d,\d/g, m => m.replace(',', '.'))
        })

        if (input.value) {
          const putData = { content: input.value }

          await $axios.put(`Notification/${task.notification.id}`, putData)
          await $axios.post(`Notification/send`, postData).then(() => {
            emitter.emit('calendarRefreshed')
            emitter.emit('taskChanged', { taskId: task.id })
          })

          if (showAlert) {
            await Swal.fire('Wysłano wiadomość SMS', '', 'success')
          }
        }
      } catch (e) {
        await Swal.fire('Nie udało się wysłać wiadomości SMS', `System nie był w stanie wysłać wiadomości SMS. <br> <span class="fw-bold">Kod błędu: ${e.response.status}</span>`)
        console.log(e)
      }
    }
  }
}

export default notificationsModule
